import "./GarbageDisposalRepair.module.css";
import Header from "@/reusable_sections/Header";
import DisposalHero from "./sections/DisposalHero";
import GarbageDisposal from "./sections/GarbageDisposal";
import DisposalProblems from "./sections/DisposalProblems";
import WarningSigns from "./sections/WarningSigns";
import DisposalDiagnostics from "./sections/DisposalDiagnostics";
import RelatedServices from "./sections/RelatedServices";
import ProblemCategories from "./sections/ProblemCategories";
import JonesboroArea from "./sections/JonesboroArea";
import DisposalFaq from "./sections/DisposalFaq";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function GarbageDisposalRepairPage() {
  return <div>
      <Header />
      <DisposalHero />
      <GarbageDisposal />
      <DisposalProblems />
      <WarningSigns />
      <DisposalDiagnostics />
      <RelatedServices />
      <ProblemCategories />
      <JonesboroArea />
      <DisposalFaq />
      <EmergencyCta />
      <Footer />
    </div>;
}